<template>
  <el-card>
    <div v-wechat-title="title" />

    <template #header>
      <content-header />
    </template>

    <el-row type="flex" justify="left">
      <el-col :span="20">
        <div style="margin: 8px;" />
        <!-- <el-button>选择商品</el-button> -->
      </el-col>
      <el-col v-if="hasPermOrderBuyOffline" :span="4">
        <span class="text item">
          <el-popconfirm title="确认下单吗？" @confirm="onSubmitOrder()">
            <el-button type="primary" slot="reference">确认下单</el-button>
          </el-popconfirm>
        </span>
      </el-col>
    </el-row>

    <el-divider content-position="left">订单信息</el-divider>

    <el-row type="flex" justify="left">
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        style="width:1100px;"
        :submit-text="'确认下单'"
        :form.sync="form"
        :errors.sync="errors"
        :edit-mode="editMode"
        :info-mode="true"
        :disable-stay="true"
      >
        <el-form-item label="商品列表" prop="items">
          <el-col>
            <el-button size="mini" type="primary" @click="addGoods" plain>添加商品</el-button>
          </el-col>
          <el-col>
            <el-card>
              <el-table :data="form.items" style="width: 100%" height="320">
                <el-table-column prop="name" label="商品名称">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.goods_id" filterable placeholder="请选择商品">
                      <el-option v-for="item in goodsList" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column prop="price" label="价格" width="80" />
                <el-table-column prop="nums" label="购买数量" width="155">
                  <template slot-scope="scope">
                    <el-input-number v-model="scope.row.nums" size="small" :min="1" :max="99999" />
                  </template>
                </el-table-column>
                <el-table-column prop="amount" label="小计" width="110" />
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-popconfirm
                      confirm-button-text="好的"
                      cancel-button-text="不用了"
                      icon="el-icon-info"
                      icon-color="red"
                      title="确定要删除商品吗？"
                      @confirm="onDestroyConfirm(scope.row)"
                    >
                      <el-button type="danger" size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-form-item>

        <el-form-item label="所属仓库">
          <el-row :gutter="12">
            <el-card>
              <el-col>
                <div class="text item" style="display: flex;justify-content: flex-start;">
                  <span style="width: 80px;text-align: right;">仓库信息：</span>
                  <el-select v-model="form.warehouse_code" clearable filterable placeholder="请选择所属仓库">
                    <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.code">
                      <span style="float: left">{{ item.name }}<span v-if="item.is_default == 1" style="color:coral">[默认]</span></span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.city + '/' + item.address }}</span>
                    </el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col style="margin-bottom:20px;" />
            </el-card>
          </el-row>
        </el-form-item>

        <el-form-item label="物流信息">
          <el-row :gutter="12">
            <el-card>
              <el-col :span="11" style="margin-bottom:10px;">
                <div class="text item" style="display: flex;justify-content: flex-start;">
                  <span style="width: 80px;text-align: right;">姓名:</span>
                  <el-input style="width: 80%;margin-left: 10px;" v-model="form.ship_name" />
                </div>
              </el-col>
              <el-col :span="11" style="margin-bottom:10px;">
                <div class="text item" style="display: flex;justify-content: flex-start;">
                  <span style="width: 80px;text-align: right;">电话:</span>
                  <el-input style="width: 80%;margin-left: 10px;" v-model="form.ship_mobile" />
                </div>
              </el-col>
              <el-col :span="11">
                <div class="text item" style="display: flex;justify-content: flex-start;">
                  <span style="width: 80px;text-align: right;">省市地区:</span>
                  <city-cascader style="width: 80%;margin-left: 10px;" ref="cityCascader" v-model="form.ship_aera_code" />
                </div>
              </el-col>
              <el-col :span="11">
                <div class="text item" style="display: flex;justify-content: flex-start;">
                  <span style="width: 80px;text-align: right;">地址信息:</span>
                  <el-input style="width: 80%;margin-left: 10px;" v-model="form.ship_addr" />
                </div>
              </el-col>
              <el-col style="margin-bottom:20px;" />
            </el-card>
          </el-row>
        </el-form-item>

        <el-form-item label="结算信息">
          <el-row :gutter="12">
            <el-card>
              <el-col :span="11" style="margin-bottom:10px;">
                <div class="text item">订单号:<span style="color: #999999;font-size: 13px; margin-left: 5px;">系统生成</span></div>
                <div class="text item">下单时间:<span style="color: #999999;font-size: 13px; margin-left: 5px;">系统当前时间</span></div>
              </el-col>
              <el-col :span="11">
                <div class="text item">
                  总金额:<span style=" margin-left: 5px;">{{ form.total_amount }} </span>元
                </div>
                <!-- <div class="text item">
                  运费:<span style=" margin-left: 5px;">{{ form.freight }}</span> 元
                </div> -->
                <div class="text item" style="color: #303133;font-size:18px;">
                  实付金额:<span style="color: red; margin-left: 5px;">{{ form.final_amount }}</span> 元
                </div>
              </el-col>
              <el-col style="margin-bottom:20px;">
                <el-input type="textarea" :autosize="{ minRows: 1, maxRows: 2 }" placeholder="订单说明" v-model="form.memo" />
              </el-col>
            </el-card>
          </el-row>
        </el-form-item>
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import { createOrder, storeOrder, updateOrder } from '@/api/order-offline'
import { can } from '@/libs/utils'
import CityCascader from '@c/CityCascader'
import LzForm from '@c/LzForm'
import FormHelper from '@c/LzForm/FormHelper'

export default {
  name: 'Form',
  components: {
    LzForm,
    CityCascader,
  },
  mixins: [FormHelper],
  data() {
    return {
      title: '编辑订单',
      form: {
        id: 0,
        title: '',
        item_num: 0,
        total_amount: 0.0,
        final_amount: 0.0,
        ship_name: '',
        ship_mobile: '',
        ship_area: '',
        ship_aera_code: [],
        ship_addr: '',
        memo: '',
        pick_up_order: '',
        items: [],
        warehouse_code: '',
      },

      errors: {},
      hasPermOrderBuyOffline: false,

      goodsList: [],

      warehouseList: [],
    }
  },
  computed: {},
  created() {
    this.hasPermOrderBuyOffline = can('order.offline.create')
  },
  methods: {
    async getData() {
      const { data } = await createOrder()
      const { goods, warehouses } = data
      this.goodsList = goods
      this.warehouseList = warehouses
      if (warehouses.length > 0) {
        this.defaultWarehouse = warehouses[0]['code']
        this.form.warehouse_code = this.defaultWarehouse
      }
    },

    async onSubmit() {
      if (this.editMode) {
        await updateOrder(this.resourceId, this.form)
      } else {
        await storeOrder(this.form)
      }
    },

    async onSubmitOrder() {
      if (await this.componentGoodsList()) {
        this.$message({
          message: '选购商品中存在有空项，请补充完善。',
          type: 'warning',
        })
        return
      }
      this.form.ship_area = this.$refs['cityCascader'].$refs['CityCascader'].inputValue
      this.form.ship_area = this.form.ship_area.replace(/\s*/g, '')

      const res = await storeOrder(this.form)
      console.log(res)
      if (res.status === 201) {
        this.$message.success('下单成功.')
        this.resetForm()
      }
    },

    async addGoods() {
      this.form.items.push({
        goods_id: '',
        name: '',
        price: 0,
        nums: 1,
        amount: 0,
      })
    },

    async filterGood(goods_id) {
      const goods = this.goodsList.filter(item => {
        return item.id === goods_id
      })

      return goods[0] || {}
    },

    async componentGoodsList() {
      let isEmptyIn = false

      this.form.items.forEach(async item => {
        console.log('item:', item)
        if (item.goods_id == 0 || item.goods_id == '') {
          isEmptyIn = true
          return
        }

        const goods = await this.filterGood(item.goods_id)
        if (goods && goods.id) {
          item.name = goods.name
          item.price = goods.price
          const nums = item.nums
          item.amount = Number(item.price * nums).toFixed(1)
        }
      })
      console.log('isEmptyIn', isEmptyIn)
      return isEmptyIn
    },

    async onDestroyConfirm(item) {
      const index = this.form.items.indexOf(item)
      if (index !== -1) {
        this.form.items.splice(index, 1)
      }
    },

    resetForm() {
      this.form = {
        id: 0,
        title: '',
        item_num: 0,
        total_amount: 0.0,
        final_amount: 0.0,
        memo: '',
        pick_up_order: '',
        items: [],
      }
    },
  },
  watch: {
    'form.items': {
      handler(newGoods) {
        console.log(newGoods)
        let amount = 0.0
        newGoods.forEach(async item => {
          const goods = await this.filterGood(item.goods_id)
          if (goods && goods.id) {
            item.name = goods.name
            item.price = goods.price
            const nums = item.nums
            item.amount = Number(item.price * nums).toFixed(1)
          }

          amount += Number(item.amount)
          console.log(item, goods, amount)

          this.form.total_amount = this.form.final_amount = Number(amount).toFixed(1)
        })
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style scoped lang="scss"></style>
